<ion-header [translucent]="true" class="ninja">
  <ion-toolbar class="thin-toolbar" mode="ios">
  </ion-toolbar>
</ion-header>

<ion-content [forceOverscroll]="false">
  <div class="tr-public-container tr-start-height old-style">
    <div class="h-100 w-100 d-flex flex-column">
      <div class="pt-5 pb-4">
        <a href="https://{{appVariables.WHITELABEL_LINK}}"><img class="d-block mx-auto logo" src="assets/img/{{appVariables.WHITELABEL_LOGO}}"alt="{{appVariables.WHITELABEL_BRAND}}"/></a>
      </div>
      <div
        class="tr-start-box col-xs-12 col-sm-8 col-md-6 col-lg-4 offset-sm-2 offset-md-3 offset-lg-4">
        <form [formGroup]="form" class="p-3 m-0" id="restorePass" name="form" (ngSubmit)="sending=true; submit()">
          <h2 class="mb-3 into">Restore password</h2>
          <div class="form-group">
            <label for="password" class="control-label">Password</label>
            <input
              id="password"
              type="password"
              formControlName="password"
              autocomplete="off"
              class="form-control"
              [ngClass]="{'is-invalid': form.controls.password.touched && form.controls.password.invalid}"
            />
            <control-messages [control]="form.get('password')"></control-messages>
          </div>
          <div class="form-group">
            <label for="passwordConfirmation" class="control-label">Password confirmation</label>
            <input
              id="passwordConfirmation"
              type="password"
              formControlName="passwordConfirmation"
              autocomplete="off"
              class="form-control"
              [ngClass]="{'is-invalid': form.controls.passwordConfirmation.touched && form.controls.passwordConfirmation.invalid}"
            />
            <control-messages [control]="form.get('passwordConfirmation')"></control-messages>
          </div>
          <button
            id="login-button"
            type="submit"
            class="btn btn-info btn-lg w-100 mb-2"
            [disabled]="form.invalid || sending"
          >Set new password</button>
        </form>
      </div>
    </div>
  </div>
</ion-content>
